import { formatCredits, formatRelative } from '../../lib/format';
import type { Transaction } from '../../types';
import { Icon } from '../ui/Icon';
import styles from './TransactionList.module.css';

export function TransactionList({ transactions }: { transactions: Transaction[] }) {
  return (
    <div className={styles.list}>
      {transactions.map((transaction) => {
        const tone = transaction.kind === 'earn' ? styles.earn : styles.spend;
        return (
          <div key={transaction.id} className={`${styles.item} ${tone}`}>
            <span className={styles.icon}>
              <Icon name={transaction.kind === 'earn' ? 'plus' : 'bolt'} size={16} />
            </span>
            <span className={styles.body}>
              <span className={styles.label}>{transaction.label}</span>
              <span className={styles.time}>{formatRelative(transaction.at)}</span>
            </span>
            <span className={styles.amount}>
              {transaction.kind === 'earn' ? '+' : '−'}
              {formatCredits(transaction.amount)}
            </span>
          </div>
        );
      })}
    </div>
  );
}
